import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'zoneManagementExperience.listExport'

const ZoneManagementZoneListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ZoneManagementZoneListExportSlice
